import React, { useState, useEffect } from "react";
import axios from "axios";

const AnniversaryImages = () => {
  const [imagesByYear, setImagesByYear] = useState({});

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await axios.get(
          "https://backend.skpandco.in/gallery/anniversary"
        );
        const data = response.data;
        // Group by year
        const grouped = data.reduce((acc, item) => {
          const year = item.year;
          const images = item.images || [];
          acc[year] = images.map((imgName, index) => ({
            id: index + 1,
            src: `https://backend.skpandco.in${imgName}`,
            alt: `Anniversary Image ${index + 1}`,
          }));
          return acc;
        }, {});
        setImagesByYear(grouped);
      } catch (error) {
        console.error("Error fetching anniversary images:", error);
      }
    };
    fetchImages();
  }, []);

  return (
    <div className="anniversary-container">
      {Object.keys(imagesByYear).sort((a, b) => b - a).map((year) => (
        <div key={year} className="year-section">
          <h2 className="year-label">{year}</h2>
          <div className="image-grid">
            {imagesByYear[year].map((img) => (
              <div key={img.id} className="image-wrapper">
                <img
                  src={img.src}
                  alt={img.alt}
                  className="carousel-image"
                  onError={(e) => {
                    e.target.src = "https://via.placeholder.com/300x300?text=Image+Not+Found";
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AnniversaryImages;
